import { SearchContactsCriteria } from "../../components/SearchContacts/SearchContacts";
import ServiceEndpoints from "../ServiceEndpoints";
import { SearchContactsResults } from "../../components/SearchContacts/SearchContacts";
import { IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { Authority, Country } from "../../model/SearchContact";
import { SearchError } from "./SearchService";

export const searchContactsCriteriaForm = async(
  searchContactsCriteria: SearchContactsCriteria,
  token: any
): Promise<SearchContactsResults | SearchError> => {
  const searchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(searchContactsCriteria),
  };

  try {
    const response = await fetch(
      ServiceEndpoints.SearchContacts,
      searchOptions
    );

    if (response.status === 200) {
      const data = (await response.json()) as SearchContactsResults;
      return data;
    } else {
      const errorData = await response.json();

      // Handle 400 error with field errors
      if (response.status === 400 && errorData && errorData.errors && Array.isArray(errorData.errors)) {
        return {
          message: "Validation error",
          errors: errorData.errors
        };
      }

      throw new Error("Request failed with status: " + response.status);
    }
  } catch (error) {
    console.error("API error" + error);
    return {
      results: [
        {
          firstName: "",
          lastName: "",
          country: "",
          authority: "",
          position: "",
          team: "",
          genericEmail: "",
          professionalEmail: "",
          professionalPhone: "",
          legalFrameworkDepartment: ""
        },
      ],
    };
  }
}
export const _fetchCountryOptions = async(
  selectedCountry: string,
  authToken: string
): Promise<IDropdownOption<Country>[]> => {
  try {
    const countries = await fetch(ServiceEndpoints.SearchContactCountries, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });

    const options: IDropdownOption<Country>[] = await countries
      .json()
      .then((x) =>
        x.map((country: Country) => ({
          key: country.code,
          text: country.country,
          title:country.country
        }))
      );

    const sortedOptions = options.sort((a, b) => a.text.localeCompare(b.text));

    return sortedOptions;
  } catch (error) {
    console.error("Error fetching country options:", error);
    return [];
  }
}
export const _authorityOptions = async (
  selectedAuthority: string,
  authToken: string,
  countryFilter: string = ""
): Promise<IDropdownOption<Authority>[]> => {
  try {
    const authorities = await fetch(
      `${ServiceEndpoints.SeachContactAuthorities}${countryFilter}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + authToken,
        },
      }
    );

    const options: IDropdownOption<Authority>[] = await authorities
      .json()
      .then((x) =>
        x.map((authority: Authority) => ({
          key: authority.code,
          text: authority.name,
          title:authority.name
        }))
      );

    const sortedOptions = options.sort((a, b) => a.text.localeCompare(b.text));

    return sortedOptions;
  } catch (error) {
    console.error("Error fetching authority options:", error);
    return [];
  }
};
